<template>
  <div class="add-post">
    <h1>Dodaj wpisy</h1>
    <el-form ref="addPost" :model="addPost" label-width="160px" class="add-post-form">
      <el-form-item
        label="Tytuł"
        prop="title"
        :rules="[
          { required: true, message: 'Tytuł jest wymagany'},
        ]"
      >
        <el-input v-model="addPost.title" type="title" autocomplete="off" />
      </el-form-item>
      <el-form-item
        label="Zdjęcie"
        prop="image"
        :rules="[
          { required: true, message: 'Zdjęcie jest wymagane'},
        ]"
      >
        <el-upload
          class="upload"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :on-change="handleChangeImages"
          :auto-upload="false"
          :limit="1"
          :file-list="fileList"
        >
          <el-button size="small" type="primary">Dodaj zdjęcie</el-button>
          <div slot="tip" class="el-upload__tip">jpg/png zdjęcia nie większe niż 5 MB</div>
        </el-upload>
        <el-dialog :visible.sync="previewDialogVisible">
          <img width="100%" :src="previewDialogUrl" alt="">
        </el-dialog>
      </el-form-item>
      <el-form-item
        label="Treść"
        prop="content"
        :rules="[
          { required: true, message: 'Treść jest wymagana'},
        ]"
      >
        <vue-editor v-model="addPost.content" use-custom-image-handler :editor-options="editorSettings" @image-added="handleImageAdded" />
      </el-form-item>

      <el-divider content-position="left">SEO i Open Graph</el-divider>

      <el-form-item label="Meta title">
        <el-input v-model="addPost.meta_title" placeholder="Domyślnie = tytuł" maxlength="255" show-word-limit />
      </el-form-item>

      <el-form-item label="Meta description">
        <el-input v-model="addPost.meta_description" type="textarea" :rows="3" maxlength="500" show-word-limit />
      </el-form-item>

      <el-form-item label="Meta keywords">
        <el-input v-model="addPost.meta_keywords" maxlength="500" show-word-limit placeholder="słowo1, słowo2, słowo3" />
      </el-form-item>

      <el-form-item label="OG image">
        <el-upload
          :on-change="handleOgImageChange"
          :on-remove="handleOgImageRemove"
          :auto-upload="false"
          :limit="1"
          :file-list="ogImageList"
          accept="image/*"
        >
          <el-button size="small" type="primary">Wybierz obraz</el-button>
          <div slot="tip" class="el-upload__tip">JPG/PNG/WEBP, max 2MB. Zalecane 1200x630px.</div>
        </el-upload>
      </el-form-item>

      <el-divider content-position="left">Publikacja</el-divider>

      <el-form-item label="Status">
        <el-select v-model="addPost.status">
          <el-option label="Szkic" value="draft" />
          <el-option label="Zaplanowany" value="scheduled" />
          <el-option label="Opublikowany" value="active" />
          <el-option label="Nieaktywny" value="in_active" />
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="addPost.status === 'scheduled'"
        label="Data publikacji"
        prop="scheduled_at"
        :rules="[{ required: true, message: 'Data publikacji jest wymagana dla zaplanowanego posta' }]"
      >
        <el-date-picker
          v-model="addPost.scheduled_at"
          type="datetime"
          format="dd.MM.yyyy HH:mm"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="datePickerOptions"
          placeholder="Wybierz datę i godzinę publikacji"
        />
        <div class="el-form-item__tip">Post pojawi się publicznie automatycznie (cron sprawdza co 10 min).</div>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submitForm()">Zapisz</el-button>
      </el-form-item>
    </el-form>
    <AddHtmlDialog
      v-model="htmlContent"
      :dialog-visible="insertDialog"
      @dialogContentChanged="updateValHtml"
      @close="insertDialog = false"
    />
  </div>
</template>

<script>

import { VueEditor, Quill } from 'vue2-editor';

import ImageResize from 'quill-image-resize-vue';
import { ImageDrop } from 'quill-image-drop-module';

import PostResource from '@/api/post';
const postResource = new PostResource();

Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageResize', ImageResize);
import AddHtmlDialog from '@/views/newsletter/AddHtmlDialog';

var icons = Quill.import('ui/icons');
icons['undo'] = '<svg width="800px" height="800px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><rect x="0" fill="none" width="20" height="20"/><g><path d="M4 16v-2H2v2H1v-5h1v2h2v-2h1v5H4zM7 16v-4H5.6v-1h3.7v1H8v4H7zM10 16v-5h1l1.4 3.4h.1L14 11h1v5h-1v-3.1h-.1l-1.1 2.5h-.6l-1.1-2.5H11V16h-1zM19 16h-3v-5h1v4h2v1zM9.4 4.2L7.1 6.5l2.3 2.3-.6 1.2-3.5-3.5L8.8 3l.6 1.2zm1.2 4.6l2.3-2.3-2.3-2.3.6-1.2 3.5 3.5-3.5 3.5-.6-1.2z"/></g></svg>';

export default {
  name: 'AddPost',
  components: {
    VueEditor,
    AddHtmlDialog,
  },
  data() {
    return {
      local_value: '',
      htmlContent: '',
      insertDialog: false,
      addPost: {
        title: '',
        content: '',
        image: null,
        status: 'active',
        scheduled_at: null,
        meta_title: '',
        meta_description: '',
        meta_keywords: '',
      },
      fileList: [],
      ogImageFile: null,
      ogImageList: [],
      previewDialogVisible: false,
      previewDialogUrl: '',
      datePickerOptions: {
        disabledDate(date) {
          // Zezwalamy na dzisiaj (cron odpali później) — blokujemy tylko dni w przeszłości.
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return date < today;
        },
      },
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {},
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ header: [false, 1, 2, 3, 4, 5, 6] }],
              [
                { align: '' },
                { align: 'center' },
                { align: 'right' },
                { align: 'justify' },
              ],
              ['blockquote', 'code-block'],
              [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
              [{ script: 'sub' }, { script: 'super' }],
              [{ indent: '-1' }, { indent: '+1' }],
              [{ color: [] }, { background: [] }],
              [{ direction: 'rtl' }],
              ['image'],
              [{ undo: 'undo' }],
            ],
            handlers: {
              undo: () => {
                this.openInsertDialog();
              },
            },
          },
        },
      },
    };
  },
  watch: {
    value(value) {
      if (value !== this.local_value) {
        this.addPost.content = this.value;
        this.$emit('set-value', value);
      }
    },
    'addPost.content'(value) {
      this.$emit('set-value', value);
    },
    'addPost.status'(newStatus) {
      // Czyszczenie daty kiedy użytkownik zmienia status z scheduled na coś innego —
      // wartość zostawiona w formularzu wprowadzałaby admina w błąd.
      if (newStatus !== 'scheduled') {
        this.addPost.scheduled_at = null;
      }
    },
  },
  methods: {
    submitForm() {
      this.$refs.addPost.validate(async(valid) => {
        if (!valid) {
          this.$notify({
            title: 'Error',
            message: 'Popraw formularz',
            type: 'error',
            duration: 2000,
          });
          return false;
        } else {
          const formData = new FormData();
          formData.append('title', this.addPost.title);
          formData.append('content', this.addPost.content);
          formData.append('main_photo', this.addPost.image);
          formData.append('status', this.addPost.status);
          if (this.addPost.status === 'scheduled' && this.addPost.scheduled_at) {
            formData.append('scheduled_at', this.addPost.scheduled_at);
          }
          formData.append('meta_title', this.addPost.meta_title || '');
          formData.append('meta_description', this.addPost.meta_description || '');
          formData.append('meta_keywords', this.addPost.meta_keywords || '');
          if (this.ogImageFile) {
            formData.append('og_image', this.ogImageFile);
          }
          await postResource.store(formData);
          await this.$router.push({ path: '/blog/posts-list' });
        }
      });
    },
    handlePreview(file) {
      this.previewDialogUrl = file.url;
      this.previewDialogVisible = true;
    },
    handleChangeImages(file) {
      this.addPost.image = file.raw;
    },
    async handleRemove() {
      this.addPost.image = null;
    },
    handleOgImageChange(file) {
      this.ogImageFile = file.raw;
      this.ogImageList = [file];
    },
    handleOgImageRemove() {
      this.ogImageFile = null;
      this.ogImageList = [];
    },
    openInsertDialog() {
      this.insertDialog = true;
    },
    updateValHtml(value) {
      this.htmlContent = value;
      this.addPost.content = this.htmlContent;
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      const formData = new FormData();
      formData.append('image', file);
      const result = await postResource.imgStore(formData);
      Editor.insertEmbed(cursorLocation, 'image', result);
      resetUploader();
    },
  },
};
</script>

<style lang="scss" scoped>
  .add-post {
    margin: 0 30px;
    .el-form-item__tip {
      font-size: 12px;
      color: #909399;
      margin-top: 4px;
    }
  }
</style>
